export default function SelectTab({
  tabs,
  activeTab,
  onTabChange,
  direction = "horizontal",
}) {
  return (
    <div>
      <div className="flex flex-wrap gap-4">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            style={{
              backgroundImage: `url("${tab.imageSrc}")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            className={`w-[calc(33.333%-1rem)] px-4 py-2 h-16 text-sm font-medium rounded-2xl transition cursor-pointer flex items-end justify-center text-center ${
              activeTab === tab.key
                ? "text-white border-2 border-blue-500"
                : "bg-black text-gray-700 hover:opacity-80"
            }`}
          >
            {tab.label}
          </div>
        ))}
      </div>
    </div>
  );
}
